export default "__VITE_ASSET__DRUrZdjj__"